import { pathogenicitiesSortingArray } from "../../../../pages/variant/components/Lovd/components/constants";

export const getPathogenicityAndEffectObject = (lovdData) => {
  const individuals = lovdData?.[0]?.individuals;
  const pathogenicities = lovdData?.[0]?.pathogenicities;
  const pathogenicityAndEffectObject = {};

  const individual = individuals?.[0];
  const currentVariants = individual?.variants?.filter((variant) => {
    return variant?.is_current === true;
  });
  const currentVariant = currentVariants?.[0] || null;
  const pathogenicity = currentVariant ? currentVariant.pathogenicity : null;
  const iCPathogenicity = pathogenicity
    ? pathogenicity.clinical_classification_curator
    : null;
  const iSPathogenicity = pathogenicity
    ? pathogenicity.clinical_classification_submitter
    : null;
  const iCEffect = pathogenicity ? pathogenicity.effect_curator : null;
  const iSEffect = pathogenicity ? pathogenicity.effect_submitter : null;
  pathogenicityAndEffectObject.individuals_curator = {
    pathogenicity: iCPathogenicity,
    effect: iCEffect,
  };
  pathogenicityAndEffectObject.individuals_submitter = {
    pathogenicity: iSPathogenicity,
    effect: iSEffect,
  };

  const pCPathogenicity = pathogenicities
    ? pathogenicities[0]?.clinical_classification_curator
    : null;
  const pSPathogenicity = pathogenicities
    ? pathogenicities[0]?.clinical_classification_submitter
    : null;
  const pCEffect = pathogenicities ? pathogenicities[0]?.effect_curator : null;
  const pSEffect = pathogenicities
    ? pathogenicities[0]?.effect_submitter
    : null;

  pathogenicityAndEffectObject.pathogenicities_curator = {
    pathogenicity: pCPathogenicity,
    effect: pCEffect,
  };
  pathogenicityAndEffectObject.pathogenicities_submitter = {
    pathogenicity: pSPathogenicity,
    effect: pSEffect,
  };

  return pathogenicityAndEffectObject;
};

export const getPathogenicityAndEffect = (lovdData) => {
  let pathogenicity;
  let effect;
  const pathogenicityAndEffect = getPathogenicityAndEffectObject(lovdData);
  if (
    pathogenicityAndEffect?.individuals_curator &&
    pathogenicityAndEffect?.individuals_curator?.pathogenicity &&
    pathogenicitiesSortingArray.includes(
      pathogenicityAndEffect?.individuals_curator?.pathogenicity?.toLowerCase()
    )
  ) {
    pathogenicity = pathogenicityAndEffect.individuals_curator.pathogenicity;
    effect = pathogenicityAndEffect.individuals_curator.effect;
    return [pathogenicity, effect];
  }
  if (
    pathogenicityAndEffect?.pathogenicities_curator &&
    pathogenicityAndEffect?.pathogenicities_curator?.pathogenicity &&
    pathogenicitiesSortingArray.includes(
      pathogenicityAndEffect?.pathogenicities_curator?.pathogenicity?.toLowerCase()
    )
  ) {
    pathogenicity =
      pathogenicityAndEffect.pathogenicities_curator.pathogenicity;
    effect = pathogenicityAndEffect.pathogenicities_curator.effect;
    return [pathogenicity, effect];
  }
  if (
    pathogenicityAndEffect?.individuals_submitter &&
    pathogenicityAndEffect?.individuals_submitter?.pathogenicity &&
    pathogenicitiesSortingArray.includes(
      pathogenicityAndEffect?.individuals_submitter?.pathogenicity?.toLowerCase()
    )
  ) {
    pathogenicity = pathogenicityAndEffect.individuals_submitter.pathogenicity;
    effect = pathogenicityAndEffect.individuals_submitter.effect;
    return [pathogenicity, effect];
  }
  if (
    pathogenicityAndEffect?.pathogenicities_submitter &&
    pathogenicityAndEffect?.pathogenicities_submitter?.pathogenicity &&
    pathogenicitiesSortingArray.includes(
      pathogenicityAndEffect?.pathogenicities_submitter?.pathogenicity?.toLowerCase()
    )
  ) {
    pathogenicity =
      pathogenicityAndEffect.pathogenicities_submitter.pathogenicity;
    effect = pathogenicityAndEffect.pathogenicities_submitter.effect;
    return [pathogenicity, effect];
  }
  return [pathogenicity, effect];
};
